export const NAVIGATING_FOLDERS = 'NAVIGATING_FOLDERS';
export const SET_CURRENT_FOLDER_PATH = 'SET_CURRENT_FOLDER_PATH';
export const SET_FOLDER_MAPS = 'SET_FOLDER_MAPS';
export const CLEAR_FOLDER_MAP = 'CLEAR_FOLDER_MAP';
export const IS_FETCHING_FOLDERS = 'IS_FETCHING_FOLDERS';
export const IS_FETCHING_FOLDERS_COMPLETE = 'IS_FETCHING_FOLDERS_COMPLETE';

export const navigatingFolders = (value) => {
  return {
    type: NAVIGATING_FOLDERS,
    payload: value,
  };
};

export const setFolderMaps = (folders) => ({
  type: SET_FOLDER_MAPS,
  payload: {
    folders,
  },
});

export const setCurrentFolderPath = (newFolderPath) => ({
  type: SET_CURRENT_FOLDER_PATH,
  payload: {
    path: newFolderPath,
  },
});

export const clearFolderMap = () => ({
  type: CLEAR_FOLDER_MAP,
});

export const fetchingFolders = () => ({
  type: IS_FETCHING_FOLDERS,
});

export const fetchingFoldersComplete = () => ({
  type: IS_FETCHING_FOLDERS_COMPLETE,
});
